import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useCloseTemplates } from "@api/closeTemplate.api";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const CloseTemplateFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: templates = [] } = useCloseTemplates();

    const options = useMemo<FilterMultiselectOption[]>(
        () =>
            templates.map((template) => ({
                value: template.id,
                label: template.name,
                searchableLabel: template.name,
            })),
        [templates],
    );

    const value = filters.closeTemplateIds ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val.map(String);
                    onChange({
                        closeTemplateIds: selected.length
                            ? selected
                            : undefined,
                    });
                }}
                name="closeTemplate"
                onBlur={noop}
            />
        </div>
    );
};
